import {useDesktop} from 'hooks';
import {useEffect, useState} from 'react';

export const useScrollCategories = () => {
  const [activeCategory, setActiveCategory] = useState<string>();
  const isDesktop = useDesktop();

  const valueHorizontalScroll = isDesktop ? 20 : 115;

  useEffect(() => {
    const lastActiveRef = {current: activeCategory};

    const getCategorySections = () => document.querySelectorAll<HTMLElement>('section[id^="category-"]');

    const handleScroll = () => {
      const sections = getCategorySections();
      if (!sections.length) return;

      const scrollY = window.scrollY + valueHorizontalScroll;
      let currentSectionId: string | undefined;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (scrollY >= sectionTop - 1) {
          currentSectionId = section.getAttribute('id') || undefined;
        }
      });

      if (currentSectionId && lastActiveRef.current !== currentSectionId) {
        lastActiveRef.current = currentSectionId;
        setActiveCategory(currentSectionId);
      }
    };

    const initActive = () => {
      const hash = (typeof window !== 'undefined' && window.location.hash) || '';
      const currentHashId = hash.startsWith('#') ? hash.slice(1) : '';
      const sections = getCategorySections();

      const initialId =
        currentHashId && currentHashId.startsWith('category-')
          ? currentHashId
          : sections.length
          ? sections[0].id
          : undefined;
      if (initialId) setActiveCategory(initialId);
    };

    initActive();
    window.addEventListener('scroll', handleScroll, {passive: true});
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueHorizontalScroll, setActiveCategory]);

  return {activeCategory, setActiveCategory};
};
